<template>
  <svg :width="width" :height="height" :class="className" :color="color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/></svg>
</template>

<script>
export default {
  name: "IconCircleFilled",
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#0a2336'
    },
    width: {
      type: String,
      default: '1.2em'
    },
    height: {
      type: String,
      default: '1.2em'
    },
  },
}
</script>